import request from '../utils/http'
// 列表（日志）
export function index (query) {
  return request({
    url: '/accountLog/index',
    method: 'GET',
    params: query
  })
}
// 操作记录（即将废弃）
export function record (query) {
  return request({
    url: '/accountLog/record',
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/accountLog.js